import axiosIS from '@/api/net/axios.js';
import { baseUrl, apiconfig } from '@/config/apiConfig.js';

export function saveReferenceMusicTmp(data = {}, options = {}) {
  return axiosIS(
    `${baseUrl}/api/pgc/parse/music_link`,
    data,
    { method: 'post', preParams: data, ...options }
  );
}

// 加入购物车
export function addCart(data = {}) {
  return axiosIS(
    `${baseUrl}/api/pgc/cart/add`,
    data,
    { method: 'post', preParams: data }
  );
}

// 获取枚举
export function miscConfig(data = {}) {
  return axiosIS(
    `${baseUrl}/api/misc/config`,
    data,
    { method: 'get' }
  );
}

// 订单支付
export function payOrder(channel,data = {}) {
  return axiosIS(
    `${baseUrl}/api/payment/${channel}/purchase-entry`,
    data,
    { method: 'get' }
  );
}

// 检查订单
// https://rg975ojk5z.feishu.cn/wiki/PugBw1pr3iDzZWkKBaicmIbanwc
export function checkSongOrder(data = {}) {
  return axiosIS(
    `${baseUrl}/api/pgc/order/check`,
    data,
    { method: 'post' }
  );
}

// 获取用户真实信息
export function getRealityUser(data = {}) {
  return axiosIS(
    `${baseUrl}/${apiconfig}/user/reality`,
    data,
    { method: 'get' }
  );
}

// 更新用户真实信息
export function updateRealityUser(data = {}) {
  return axiosIS(
    `${baseUrl}/api/user/reality/update`,
    data,
    { method: 'post' }
  );
}

// 举报  
export function reportMusic(data = {}) {
  return axiosIS(
    `${baseUrl}/api/misc/report`,
    data,
    { method: 'post' }
  );
}


// 活动配置
export function getActivityConfig(data = {}) {
  return axiosIS(
    `${baseUrl}/api/pgc/activity/config`,
    data,
    { method: 'get' }
  );
}

// 获取用户状态
export function queryCreateModeState(data = {}) {
  return axiosIS(
    `${baseUrl}/api/pgc/query/general/report/state`,
    data,
    { method: 'get' }
  );
}

// 上报用户状态
export function reportUserState(data = {}) {
  return axiosIS(
    `${baseUrl}/api/pgc/general/report`,
    data,
    { method: 'post' }
  );
}

// 统一用户弹窗控制
export function showWindowPopup(data = {}) {
  return axiosIS(
    `${baseUrl}/api/pgc/popup/window`,
    data,
    { method: 'get' }
  );
}

// 统一用户弹窗控制
export function transMidiToMp3(data = {}) {
  return axiosIS(
    `${baseUrl}/api/misc/midi/convert`,
    data,
    { method: 'post' }
  );
}

// 
export function getSongInfo(data = {}) {
  return axiosIS(
    `${baseUrl}/api/pgc/song/info`,
    data,
    { method: 'get' }
  );
}

export const getOriginalCountryList = (data = {}) => {
  return axiosIS(
    `${baseUrl}/api/open/country-list`,
    data,
    { method: 'get' }
  );
}

export const postUserProfile = (data = {}) => {
  return axiosIS(
    `${baseUrl}/api/user/profile/report`,
    data,
    { method: 'post' }
  );
}


export default {
  saveReferenceMusicTmp,
  addCart,
  miscConfig,
  reportMusic,
  getActivityConfig,
  queryCreateModeState,
  reportUserState,
  showWindowPopup,
  transMidiToMp3,
  getSongInfo,
  getOriginalCountryList,
  postUserProfile
}
